require('./helpers/bundle-manifest').register(JSON.parse("{\"dX3sW\":\"manage.js\",\"jt6Wo\":\"lock.ca02bacd.png\",\"lqwsx\":\"manage.css\"}"));